import { Button } from "primereact/button";
import {
  getAddOnClickFunc,
  getRemoveOnClickFunc,
  MappingItemForm,
} from "../lib";
import logoOptima from "./logo_OPTIMA.png";
import "./style.css";

export const MappingDataView = ({
  componentState,
  scopeStringId,
  mappingFieldsArrState,
  toastRef,
  controlButtonStringIdState,
}) => {
  const [mappingFieldsArrStateValue] = mappingFieldsArrState;

  const [controlButtonStringIdStateValue] = controlButtonStringIdState;

  return (
    <div>
      <div className="MappingDataView_header MappingItemForm_grid">
        <h2 style={{ color: "rgb(46, 193, 240)" }}>Bitrix24</h2>
        <h2 style={{ gridColumn: "3" }}>
          <img src={logoOptima} />
        </h2>
      </div>

      {mappingFieldsArrStateValue.map((mappingFieldsObj, index) => (
        <MappingItemForm
          scopeStringId={scopeStringId}
          mappingFieldsObj={mappingFieldsObj}
          key={index}
          toastRef={toastRef}
          parentComponentState={componentState}
        />
      ))}

      <div className="MappingDataView_control_button_container MappingItemForm_grid">
        {controlButtonStringIdStateValue === "add" ? (
          <Button
            size="large"
            icon="pi pi-plus"
            className="MappingDataView_control_button"
            onClick={getAddOnClickFunc(
              mappingFieldsArrState,
              controlButtonStringIdState
            )}
          />
        ) : (
          <></>
        )}

        {controlButtonStringIdStateValue === "remove" ? (
          <Button
            size="large"
            icon="pi pi-minus"
            className="MappingDataView_control_button"
            onClick={getRemoveOnClickFunc(
              mappingFieldsArrState,
              controlButtonStringIdState
            )}
          />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};
